module.exports = __webpack_public_path__ + "td/img/bind-wx-test.b5026ca9.png";